import { Editor } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'
import { PaginationPlus } from 'tiptap-pagination-plus'
import TextAlign from '@tiptap/extension-text-align'
import FontFamily from '@tiptap/extension-font-family'
import Underline from '@tiptap/extension-underline'
import { createIcons } from 'lucide'
import {
  Undo,
  Redo,
  Heading1,
  Heading2,
  Bold,
  Italic,
  Underline as UnderlineIcon,
  Strikethrough,
  Code,
  List,
  ListOrdered,
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlignJustify,
} from 'lucide'

function setupToolbarButtons(editor) {
  document.getElementById('undo-btn').onclick = () => editor.commands.undo()
  document.getElementById('redo-btn').onclick = () => editor.commands.redo()

  document.getElementById('heading1-btn').onclick = () =>
    editor.chain().focus().toggleHeading({ level: 1 }).run()
  document.getElementById('heading2-btn').onclick = () =>
    editor.chain().focus().toggleHeading({ level: 2 }).run()

  document.getElementById('bold-btn').onclick = () => editor.chain().focus().toggleBold().run()
  document.getElementById('italic-btn').onclick = () => editor.chain().focus().toggleItalic().run()
  document.getElementById('underline-btn').onclick = () =>
    editor.chain().focus().toggleUnderline().run()
  document.getElementById('strike-btn').onclick = () => editor.chain().focus().toggleStrike().run()
  document.getElementById('code-btn').onclick = () => editor.chain().focus().toggleCode().run()

  document.getElementById('bullet-list-btn').onclick = () =>
    editor.chain().focus().toggleBulletList().run()
  document.getElementById('ordered-list-btn').onclick = () =>
    editor.chain().focus().toggleOrderedList().run()

  document.getElementById('align-left-btn').onclick = () =>
    editor.chain().focus().setTextAlign('left').run()
  document.getElementById('align-center-btn').onclick = () =>
    editor.chain().focus().setTextAlign('center').run()
  document.getElementById('align-right-btn').onclick = () =>
    editor.chain().focus().setTextAlign('right').run()
  document.getElementById('align-justify-btn').onclick = () =>
    editor.chain().focus().setTextAlign('justify').run()
}

document.addEventListener('DOMContentLoaded', function () {
  if (document.getElementById('document-editor')) {
    const editor = new Editor({
      element: document.querySelector('#document-editor'),
      extensions: [
        StarterKit,
        Underline,
        FontFamily,
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        }),
        PaginationPlus.configure({
          pageHeight: 930,
          pageGap: 20,
          pageHeaderHeight: 50,
        }),
      ],
    })

    createIcons({
      icons: {
        Undo,
        Redo,
        Heading1,
        Heading2,
        Bold,
        Italic,
        Underline: UnderlineIcon,
        Strikethrough,
        Code,
        List,
        ListOrdered,
        AlignLeft,
        AlignCenter,
        AlignRight,
        AlignJustify,
      },
    })

    editor.commands.setContent(
      document.querySelector('#hidden-content').value ||
        document.querySelector('#hidden-generated-content').value ||
        '<p>Start writing your document here...</p>'
    )
    setupToolbarButtons(editor)

    document.getElementById('api-save-button').addEventListener('click', function (e) {
      e.preventDefault()

      const successAlert = document.getElementById('save-success-alert')
      const errorAlert = document.getElementById('save-error-alert')

      const content = editor.getHTML()
      const form = document.querySelector('#editor-form')
      const documentId = form.action.match(/document_generations\/(\d+)/)?.[1]

      fetch(`/steps_api/save_editor_content/${documentId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        },
        body: JSON.stringify({ content: content }),
      })
        .then(response => response.json())
        .then(data => {
          if (data.status === 'success') {
            successAlert.style.display = 'block'
            setTimeout(() => {
              successAlert.style.display = 'none'
            }, 3000)
          } else {
            errorAlert.style.display = 'block'
            setTimeout(() => {
              errorAlert.style.display = 'none'
            }, 3000)
          }
        })
        .catch(error => {
          console.error('Error:', error)
          // Show error message
          const saveStatus = document.getElementById('save-status')
          saveStatus.textContent = 'Error saving!'
          saveStatus.classList.remove('text-success')
          saveStatus.classList.add('text-danger')
        })
    })

    document.getElementById('preview-button').addEventListener('click', function () {
      let tiptapHtmlContent = `
        <style>
          p { margin-bottom: 0px !important; }
          table{
          # border-collapse: collapse;
          border: 1px solid #ccc;
        }

        td{
          border: 1px solid #ccc;
          width: 100% !important;
        }

        th{
          border: 1px solid #ccc;
          width: 100% !important;
        }
        </style>
        ${editor.getHTML()}
      `
      tiptapHtmlContent = tiptapHtmlContent.replace(/<p>\s*<\/p>/gi, '<br>')
      const documentType =
        document.querySelector('meta[name="document-type"]')?.content || 'document-preview'

      html2pdf()
        .set({
          margin: 1,
          filename: `${documentType}.pdf`,
          image: { type: 'jpeg', quality: 0.8 },
          jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }, // 8.5 x 11 inches
        })
        .from(tiptapHtmlContent)
        .save()
    })

    document.getElementById('solosuit-close-modal').onclick = function () {
      document.getElementById('export-pdf-modal').style.display = 'none'
    }

    window.onclick = function (event) {
      if (event.target === document.getElementById('export-pdf-modal')) {
        document.getElementById('export-pdf-modal').style.display = 'none'
      }
    }
  }
})
